import { useAtomValue } from "jotai/utils";

import { DataFile, DataFilter } from "interfaces";

import { fileColTypes } from "./column-types";
import { useGetDataInsight } from "./insights";

export const useFetchDataFileQuality = (dataFileId: string) => {
  return useGetDataInsight<DataFile.DataQuality>({
    fileId: dataFileId,
    name: "data_hygiene",
  });
};

export const useFetchDataSample = (dataFileId: string) => {
  return useGetDataInsight<{ [col: string]: (string | number)[] }>({
    fileId: dataFileId,
    name: "data_sample",
  });
};

export const useFetchDataFileStats = (
  dataFileId: string,
  filters?: DataFilter.Filter[]
) => {
  const { data } = useGetDataInsight<{
    [col: string]: {
      [colType in DataFile.ColType]: DataFile.ColumnStatsInterface;
    };
  }>({
    fileId: dataFileId,
    name: "file_column_stats",
    params: filters ? { filters } : undefined,
  });
  const types = useAtomValue(fileColTypes(dataFileId));

  return Object.fromEntries(
    Object.entries(data || {}).map(([column, stats]) => {
      const currType = types[column];
      if (currType) {
        return [column, stats[currType]];
      } else {
        if (Object.keys(stats).length === 1) {
          return [column, Object.values(stats)[0]];
        } else {
          return [column, stats.numeric];
        }
      }
    })
  );
};

export const useFetchFileOutlierSummary = (dataFileId: string) => {
  const { data } = useGetDataInsight<{
    [col: string]: {
      [colType in DataFile.ColType]: DataFile.ColumnOutlierSummary;
    };
  }>({
    fileId: dataFileId,
    name: "file_outlier_summary",
  });

  const types = useAtomValue(fileColTypes(dataFileId));

  return Object.fromEntries(
    Object.entries(data || {}).map(([column, outliers]) => {
      const currType = types[column];
      if (currType) {
        return [column, outliers[currType]];
      } else {
        if (Object.keys(outliers).length === 1) {
          return [column, Object.values(outliers)[0]];
        } else {
          return [column, outliers.numeric];
        }
      }
    })
  );
};
